import { type ResourceId } from '../general';

import { type EmojiId } from './emoji';

export type TransferId = ResourceId;

export interface TransfersResponse {
    id: ResourceId;
    eid: EmojiId;
    recipient_id: ResourceId;
    email: string;
    message: string;
    clear_on_transfer: boolean;
    created_at: Date;
    accepted_at?: Date;
    deleted_at?: Date;
    sender_code_accepted_at?: Date;
}

export enum TransferStatus {
    Default,
    Initiated,
    Pending,
    Accepted,
    CancelInitiated,
    Deleted,
}

export interface TransferData {
    status: TransferStatus;
    id?: TransferId;
    recipient_email?: string;
}

export type InFlightTransfers = Record<EmojiId, TransferData>;

export type UserPendingIncoming = TransfersResponse | null;

export interface TransferPostParams {
    eid: EmojiId | string;
    email: string;
    message?: string;
    clear_on_transfer?: boolean;
    force_transfer?: boolean;
}

export interface TransferCodeParams {
    code: string;
}
